import InputField from "../../../../components/generic/inputField";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "../../../../components/generic/edbutton/edButton";
import { useLocation, useNavigate } from "react-router-dom";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { ILoginAccountTypes, ILoginFlows, } from "@domains/features/LoginFlow/entities/CommonLoginData";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import PasswordValidation from "./PasswordValidation";
import ClientForgotPasswordOTP from "../ClientUser/ClientForgotPasswordOTP";
import { useSelector } from "react-redux";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { forgotPasswordState } from "../constant";
const inputfield = {
    newpass: "",
    reenter: "",
};
const NewPassword = (props) => {
    var _a;
    const device = DeviceContext();
    const [formData, setFormData] = useState(inputfield);
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isRevealRenterPwd, setIsRevealReneterPwd] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [accDetails, setAccDetails] = useState({
        accTyp: "",
        userID: ILoginAccountTypes.EQ,
        pan: "",
    });
    const handleChange = (event) => {
        setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value }));
    };
    const [error, setError] = useState(inputfield);
    const [validatedPass, setValidatedPass] = useState("");
    const [otp, setotp] = useState(0);
    const validationError = (field, value) => {
        setError(Object.assign(Object.assign({}, error), { [field]: value }));
    };
    const navigate = useNavigate();
    const location = useLocation();
    // const locationState = location.state as INewPasswordLocatoinState;
    const { data: ClientSetPassword, loader: ClientSetPasswordLoader, errorData: ClientSetPasswordError, } = useSelector((state) => state.LoginFlow.ClientSetPassword);
    const setNewPassword = () => {
        if (props.UserType == ILoginFlows.CLIENT) {
            let payload = {
                userID: props === null || props === void 0 ? void 0 : props.accountDetails.userID,
                clientSetPassword: {
                    nePwd: formData.newpass,
                    coPwd: formData.reenter,
                    accTyp: props === null || props === void 0 ? void 0 : props.accountDetails.accTyp,
                    otp: String(otp),
                },
            };
            di.login.clientSetPassword(payload);
        }
    };
    const HandleDisabled = () => {
        return !(isValidated &&
            formData.newpass === formData.reenter &&
            formData.reenter === formData.newpass &&
            otp.toString().length == 4);
    };
    React.useEffect(() => {
        if (!ClientSetPasswordLoader && !ClientSetPasswordError.isOpen) {
            if (ClientSetPassword.passwordReset)
                props.helpFlowPopup(forgotPasswordState.SUCCESS_STATE);
        }
    }, [ClientSetPassword, ClientSetPasswordLoader, ClientSetPasswordError]);
    React.useEffect(() => {
        var _a;
        if (isValidated) {
            setValidatedPass(formData === null || formData === void 0 ? void 0 : formData.newpass);
        }
        if (((_a = formData === null || formData === void 0 ? void 0 : formData.newpass) === null || _a === void 0 ? void 0 : _a.length) < (validatedPass === null || validatedPass === void 0 ? void 0 : validatedPass.length)) {
            setIsValidated(false);
        }
    }, [isValidated, formData, validatedPass]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "NewPassword-block  p-3 bg-white" },
            React.createElement(ClientForgotPasswordOTP, { setotp: setotp, resendOTPPayload: { accountDetails: props.accountDetails } }),
            React.createElement("form", { id: "NewPassword-form", onSubmit: (e) => {
                    e.preventDefault();
                } },
                React.createElement(Row, null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) ? ("") : (React.createElement(React.Fragment, null,
                        React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 input-group" }, "Forgot Password"))),
                    React.createElement("span", { className: `${(device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "DMSansMedium_18_500 txt_black-turtle"
                            : "DMSansNormal_14_400 txt_primaryGrey mt-3"}` }, "Please set a new password to secure your account"),
                    React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5 input-group" },
                        React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.newpass, onBlur: (error, event) => {
                                if (error.required)
                                    validationError(event.target.name, "This field is required");
                                else if (error.shouldBeDifferentValue) {
                                    validationError(event.target.name, "Password cannot be the same as login ID");
                                }
                                else if (error.hasWhiteSpace) {
                                    validationError(event.target.name, "No spaces allowed");
                                }
                                else
                                    validationError(event.target.name, "");
                            }, errorText: error.newpass, placeholder: "Enter a new password", id: "newpass", name: "newpass", type: isRevealPwd ? "text" : "password", required: false, autoComplete: "off", showLabel: true, prefix: React.createElement("i", { className: `edel-icon-${isRevealPwd ? "eye-show" : "eye-hide"} icon`, onClick: () => setIsRevealPwd((prevState) => !prevState) }), placeholderClassName: "floating-label ", className: "custom-form-control", shouldBeDifferentValue: (_a = props === null || props === void 0 ? void 0 : props.accountDetails) === null || _a === void 0 ? void 0 : _a.userID, highlightInputField: true, AvoidWhiteSpace: true })),
                    React.createElement(Row, null, !isValidated && (React.createElement(PasswordValidation, { password: formData.newpass, setIsValidated: setIsValidated }))),
                    React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5 input-group" },
                        React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), highlightInputField: true, onBlur: (error, event) => {
                                if (error.required)
                                    validationError(event.target.name, "This field is Required");
                                else if ((formData === null || formData === void 0 ? void 0 : formData.newpass) !== "" &&
                                    (formData === null || formData === void 0 ? void 0 : formData.reenter) !== "" &&
                                    (formData === null || formData === void 0 ? void 0 : formData.newpass) !== (formData === null || formData === void 0 ? void 0 : formData.reenter)) {
                                    validationError(event.target.name, "Password and Confirm Password should be same ");
                                }
                                else
                                    validationError(event.target.name, "");
                            }, errorText: error.reenter, defaultValue: formData.reenter, placeholder: "Re-enter new password", id: "reenter", name: "reenter", type: isRevealRenterPwd ? "text" : "password", maxLength: 10, required: false, autoComplete: "off", showLabel: true, disabled: !isValidated || error.newpass.length > 0, prefix: React.createElement("i", { className: `edel-icon-${isRevealRenterPwd ? "eye-show" : "eye-hide"} icon`, onClick: () => setIsRevealReneterPwd((prevState) => !prevState) }), placeholderClassName: "floating-label ", className: "custom-form-control renter-textbox" }))),
                !ClientSetPasswordLoader && ClientSetPasswordError.isOpen && (React.createElement(ErrorExclamation, { errorMessage: ClientSetPasswordError.error.getErrorMessageOrErrMsg() })),
                React.createElement(Row, null,
                    React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5" },
                        React.createElement(EdButton, { value: "Reset Password", className: "w-100", btnTyp: "midnight-blue", onClick: setNewPassword, disabled: HandleDisabled() })))))));
};
export default NewPassword;
